import React from 'react';
import { format } from 'date-fns';

const NumberToDate = ({ timestamp }) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const options = { month: 'short', day: '2-digit', year: 'numeric' };
  const timeOptions = { hour: 'numeric', minute: '2-digit', hour12: true };
  const datePart = date.toLocaleDateString('en-US', options);
  const timePart = date.toLocaleTimeString('en-US', timeOptions);

  return `${datePart} ${timePart}`;
};

export default NumberToDate;
